module.exports = __webpack_public_path__ + "media/images/reviewed-awards-ces-36aabfea7eb26c006f53855e05c33f15.svg";